<template>
  <div>
    <HeaderMain page="company"/>
    <div id="listUser" class="list-user list-files">
      <div class="container">
        <div class="list-user--table">
          <div class="header-table">
            <b-row>
              <b-col md="4">
                <h2 class="heading2">
                  業者数
                  <span>{{totalItems}}</span>
                </h2>
              </b-col>
              <b-col md="8">
                <div class="filter-wrapper">
                  <b-form inline class="float-md-right" @submit.prevent="">
                    <label class="mr-sm-2" for="sort-data">並び替え:</label>
                    <b-form-select
                        id="sort-data"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.sortBy"
                        :options="[
                            { text: '会社名', value: 'name' },
                            { text: '電話番号', value: 'phone' },
                            { text: 'メール', value: 'email' },
                            { text: '日にち', value: 'created_at' },
                        ]"
                    ></b-form-select>
                    <b-form-select
                        id="sort-order-data"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.sortOrder"
                        :options="[
                            { text: 'Desc', value: 'desc' },
                            { text: 'Asc', value: 'asc' }
                        ]"
                    ></b-form-select>
                    <b-form-select
                        id="per-page"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.perPage"
                        :options="[
                            { text: '10', value: 10 },
                            { text: '50', value: 50 },
                            { text: '100', value: 75 },
                        ]"
                    ></b-form-select>
                    <b-form-input
                        id="sort-order-data"
                        class="input-form"
                        type="search"
                        placeholder="Search"
                        v-model="paginations.searchQuery"
                        @input="onSearch(paginations.searchQuery)"
                        @keyup.enter.prevent="onSearch(paginations.searchQuery)"
                    ></b-form-input>
                </b-form>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="body-table files">
            <table class="table table-csUser">
              <thead class="not-sticky">
              <tr>
                <th scope="col" class="w-45"> 会社名</th>
                <th scope="col" class="w-10">登録日</th>
                <th scope="col" class=" hidden-mb w-15">電話番号</th>
                <th scope="col" class=" hidden-mb w-20">メール</th>
                <th scope="col" class="hidden-mb w-10">従業員数</th>
                <th scope="col" class="w-10"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(company,index) in companies" v-bind:key="index" @dblclick="detailCompany(company.id)" title="ダブルタップして開きます">
                <th scope="row" class="table-name w-45">
                  <div class="table-name--box">
                    <div class="favorite">
                      <img :src="company.logo" alt="" class="avt-folder" />
                    </div>
                    <div class="admin-name admin-name-break">
                      <div class="name word-break mb-name-width">{{truncate(company.company_name,15,'...')}}</div>
                    </div>
                  </div>
                </th>
                <td class="table-department hidden-mb w-10">
                  {{company.dateRegisted}}
                </td>
                <td class="table-department hidden-mb w-15">
                  {{company.representative_phone}}
                </td>
                <td class="table-role hidden-mb w-20">{{company.representative_email}}</td>
                <td class="table-phone mb-width hidden-mb w-10">
                  {{formatNumber(company.number_employees)}}
                </td>
                <td class="table-action text-right wider-click w-10">
                  <b-dropdown class="dropdownAction dropdown-files dropdown-vendor" variant="link"  toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <i class="icon-i-dot"></i>
                    </template>
                    <b-dropdown-item @click.prevent="detailCompany(company.id)">
                      <i class="icon-i-eyes"></i>
                      <span>開く</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click.prevent="editCompany(company.id)">
                      <i class="icon-i-edit"></i>
                      <span>編集</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click.prevent="copyCompany(company.id)">
                      <svg id="Group_10216" data-name="Group 10216" xmlns="http://www.w3.org/2000/svg" width="15.805" height="15.805" viewBox="0 0 15.805 15.805">
                        <path id="Path_10171" data-name="Path 10171" d="M15.558,3.634a.817.817,0,0,0-.6-.247H11.289a2.243,2.243,0,0,0-1.129.353V.847a.816.816,0,0,0-.247-.6A.817.817,0,0,0,9.314,0H5.645a2.037,2.037,0,0,0-.776.176A2.053,2.053,0,0,0,4.2.6L.6,4.2a2.052,2.052,0,0,0-.423.67A2.037,2.037,0,0,0,0,5.645v5.927a.816.816,0,0,0,.247.6.816.816,0,0,0,.6.247h4.8v2.54a.843.843,0,0,0,.847.847h8.467a.843.843,0,0,0,.847-.847V4.234A.816.816,0,0,0,15.558,3.634Zm-5.4,1.632V7.9H7.523ZM4.516,1.879V4.516H1.879ZM6.244,7.585a2.052,2.052,0,0,0-.423.67,2.037,2.037,0,0,0-.176.776v2.258H1.129V5.645H4.8A.843.843,0,0,0,5.645,4.8V1.129H9.032V4.8Zm8.432,7.091h-7.9V9.031h3.669a.843.843,0,0,0,.847-.847V4.516h3.387V14.676h0Z" transform="translate(0)" fill="#333"/>
                      </svg>
                      <span class="ml-12">コピー</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click.prevent="showModalDelete(company.id)" >
                      <i class="icon-i-trash"></i>
                      <span>削除</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
              </tbody>
            </table>
            <nav aria-label="Page navigation">
              <ul class="pagination" v-if="showPage">
                <li class="page-item" :class="hasPrev"><a class="page-link prev" @click.prevent="changePage(paginations.page_index-1)"><i class="icon-i-prev"></i></a></li>
                <li class="page-item" v-if="hasPagination" v-for="(page,i) in pageNumber" :class="disabledPage(page.value)" v-bind:key="i"><a class="page-link" v-bind:class="{'active': page.value === paginations.page_index}" @click.prevent="changePage(page.value)">{{page.text}}</a></li>
                <li class="page-item" :class="hasNext"><a class="page-link next" @click.prevent="changePage(paginations.page_index+1)"><i class="icon-i-next"></i></a></li>
              </ul>
            </nav>
          </div>
          <div class="d-flex justify-content-center mt-50" @click="addCompany">
            <button class="btn btn-createAccount btn-rounder">
              <span>業者作成</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <modalDeleteVendor @deleteCompany="deleteCompany"/>
    <modalCopyVendor @copyResponse="copyResponse" :vendor-id="idSelect" />
  </div>
</template>

<script>
import HeaderMain from '@/components/share/Header.vue'
import { BModal, VBModal } from 'bootstrap-vue'
import modalDeleteVendor from '@/views/Admin/Company/Delete'
import modalCopyVendor from '@/views/Admin/Company/Copy'
import {mapState} from 'vuex'
export default {
  name: 'List_Company_view',
  data () {
    return {
      idSelect: null,
      paginations: {
        page_index: 1,
        sortBy: 'created_at',
        sortOrder: 'desc',
        perPage: 10,
        searchQuery: '',
        typingTimer: null,
        isTyping: false
      }
    }
  },
  components: {
    HeaderMain,
    BModal,
    modalDeleteVendor,
    modalCopyVendor
  },
  methods: {
    disabledPage (value) {
      return value === this.paginations.page_index ? 'page-item-disabled' : ''
    },
    addCompany () {
      this.$router.push(`/admin/companies/add`)
    },
    editCompany (id) {
      this.$store.dispatch('adminCompany/detailCompany', id)
      this.$router.push(`/admin/companies/edit/${id}`)
    },
    copyCompany (id) {
      this.idSelect = id
      this.$bvModal.show('modalCopyVendor')
    },
    copyResponse (resp) {
      if (resp) {
        this.$store.dispatch('adminCompany/getCompany', this.paginations)
      }
    },
    detailCompany (id) {
      this.$router.push(`/admin/companies/${id}/infor`)
    },
    showModalDelete (id) {
      this.idSelect = id
      this.$root.$emit('bv::show::modal', 'modalDeleteVendor', '#modalDeleteVendor')
    },
    hideDelete () {
      this.$root.$emit('bv::hide::modal', 'modalDeleteVendor', '#modalDeleteVendor')
    },
    deleteCompany (e) {
      this.$store.dispatch('adminCompany/deleteCompany', {modal: this.hideDelete(), id: this.idSelect})
    },
    changePage (pageIndex) {
      this.paginations.page_index = pageIndex
      this.$store.dispatch('adminCompany/getCompany', this.paginations)
    },
    showPage () {
      return this.totalPages > 1
    },
    onSearch (keyword) {
      let vm = this
      vm.paginations.page_index = 1
      clearTimeout(vm.paginations.typingTimer)
      if (keyword === '') {
        vm.paginations.isTyping = false
        this.$store.dispatch('adminCompany/getCompany', vm.paginations); return
      }

      vm.paginations.typingTimer = setTimeout(() => {
        vm.$store.dispatch('adminCompany/getCompany', vm.paginations)
      }, 500)
    },
    filterDisplay () {
      let vm = this
      vm.paginations.isTyping = true
      vm.$store.dispatch('adminCompany/getCompany', vm.paginations)
    }
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  computed: {
    ...mapState({
      companies: state => state.adminCompany.companies,
      totalItems: state => state.adminCompany.totalItems,
      totalPages: state => state.adminCompany.totalPages
    }),
    pageNumber () {
      const arr = []
      if (this.totalPages === 1) {
        return arr
      }
      const start = 1
      const end = this.totalPages
      const showPageCount = 6
      if (end <= showPageCount + 3) {
        for (let i = start; i <= end; i++) {
          arr.push({text: i, value: i})
        }
        return arr
      }
      arr.push({ text: start, value: start, show: '' })
      if (this.paginations.page_index >= 5) {
        arr.push({
          text: '...',
          value: '',
          show: 1
        })
      }
      let listStart = this.paginations.page_index - Math.floor(showPageCount / 2) + 1
      if (listStart <= 1) listStart = 2
      let listEnd = listStart + showPageCount - 1
      if (listEnd >= end) listEnd = end - 1
      listStart = listEnd - showPageCount + 1
      for (let i = listStart; i <= listEnd; i++) {
        arr.push({ text: i, value: i })
      }
      if (end - this.paginations.page_index >= showPageCount) {
        arr.push({
          text: '...',
          value: '',
          show: 2
        })
      }
      arr.push({ text: end, value: end, show: '' })
      arr.map((e, index) => {
        if (e.text === '...' && e.show === 2) {
          e.value = arr[index - 1].value + 1
        }
        if (e.text === '...' && e.show === 1) {
          e.value = arr[index + 1].value - 1
        }
        return e
      })
      return arr
    },
    hasPrev () {
      return (this.paginations.page_index === 1) ? 'page-item-disabled' : ''
    },
    hasPagination () {
      return this.pageNumber.length > 1
    },
    hasNext () {
      return this.paginations.page_index === this.totalPages ? 'page-item-disabled' : ''
    }
  },
  mounted () {
    this.$store.dispatch('adminCompany/getCompany', this.paginations)
  }
}
</script>
<style scoped lang="scss">
  .page-item-disabled {
    pointer-events: none;
  }
  @import '@/assets/stylesheet/user/list_user.scss';
  @import '@/assets/stylesheet/admin/vendor.scss';
  @import "@/assets/stylesheet/auth/listfile.scss";
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/List.vue